import { buildApiUrl } from '../utils/apiConfig';
import { Webinar } from '../types/webinars';
import { apiClient } from "../utils/apiClient";

/**
 * Fetches upcoming webinars for the public landing page. This is a public,
 * unauthenticated CMS endpoint, so no credentials are sent. On any failure the
 * caller receives an empty list so the section simply renders nothing.
 */
export async function fetchWebinars(): Promise<Webinar[]> {
    try {
        const response = await apiClient(buildApiUrl('api/cms/webinars'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch webinars: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? (data as Webinar[]) : [];
    } catch (error) {
        console.error('Error fetching webinars:', error);
        return [];
    }
}
